import { motion } from 'framer-motion'
import heroTwo from 'src/Imgs/quienSomosBG2.png'
import fakeImage from 'src/Imgs/quienSomosBG.png'
import logoTecnicall from 'src/Imgs/newIcons/logoTecnicall.png'
// import personOne from 'src/Imgs/newIcons/personOne.png'
import bgCEO from 'src/Imgs/newIcons/bgCEO.png'
import personTwo from 'src/Imgs/newIcons/personTwo.png'
import { Link } from 'react-router-dom'

import { useEffect } from 'react'

// "https://pideypasa-s3.s3.amazonaws.com/Images/webpage/aboutUs.webp";

function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <motion.div
        initial={{ x: -400 }}
        transition={{ duration: 1.2 }}
        animate={{ x: 0 }}
      >
        <div className="relative  h-[500px] md:h-[35rem] flex items-center ">
          <div
            className="absolute inset-0 bg-no-repeat bg-center "
            style={{
              backgroundImage: `url(${heroTwo})`,
              backgroundSize: 'cover'
            }}
          />
          <div className="flex justify-center  md:w-[100%] ">
            <div className="container">
              <div className="relative  max-w-[900px]  ">
                <div className="px-[35px] flex flex-col items-center md:items-start text-center md:text-start">
                  <h1 className="text-white text-3xl md:text-5xl font-bold ">
                    Somos una organización con personal IT
                  </h1>
                  <p className="text-white text-justify md:text-left text-base md:text-lg mb-[50px] mt-[50px]">
                    Con más de 10 años de experiencia co-creando con el usuario
                    para realizar proyectos sostenibles y viables. Nos
                    especializamos en el desarrollo de negocios digitales.
                  </p>
                  <a
                    href="https://tecnicall.com.co/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <motion.button
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 1 }}
                      className="bg-white w-[180px] h-[40px] rounded-3xl font-semibold "
                    >
                      Más Información
                    </motion.button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center ">
          <div className="container px-[35px]">
            <div className="flex justify-center  mb-[30px] ">
              <div className="md:w-[100%]">
                <h1 className="text-center md:text-start text-3xl md:text-5xl  mt-[30px] mb-[30px] tituloPrincipal ">
                  ¿Quienes somos?
                </h1>
                <p className="text-justify text-base md:text-lg  textoGeneral">
                  Somos TECNICALL COLOMBIA S.A.S, una empresa en crecimiento con
                  sede en Barranquilla, Colombia. Contamos con una amplia
                  experiencia en la industria tecnológica, lo que nos ha
                  permitido participar en el desarrollo de proyectos
                  empresariales para el sector retail en la ciudad. Nuestro
                  enfoque se basa en la colaboración estrecha con los usuarios
                  para co-crear proyectos sostenibles y viables. Nos destacamos
                  en el desarrollo de negocios digitales, ofreciendo soluciones
                  innovadoras y adaptadas a las necesidades del mercado actual.
                </p>
              </div>
            </div>

            <div className="hidden md:block mb-[50px] justify-center md:justify-start mb-[50px ] ">
              <div className="flex  items-center">
                <div className="items-center mt-[25px]">
                  <img
                    src={logoTecnicall}
                    className="max-w-[200px] mb-[30px]"
                  />
                </div>
                <div className="border-l-2 pl-[10px] ml-[10px] flex items-center">
                  <p className="flex">
                    &nbsp; Solutions{' '}
                    <p className="font-bold">&nbsp; Information Technology</p>
                  </p>
                </div>
              </div>
            </div>

            <div className="md:hidden flex flex-col items-center mb-[50px] justify-center md:justify-start mb-[50px ] ">
              <div className="items-center mt-[25px]">
                <img src={logoTecnicall} className="max-w-[200px] mb-[30px]" />
              </div>
              <div className=" pl-[10px] ml-[10px] flex items-center">
                <p className="flex font-semibold">
                  <p className="font-normal">Solutions</p> &nbsp; Information
                  Technology
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 md:gap-10 md:mb-[80px]">
              <div className="flex flex-col my-[30px]">
                <img src={bgCEO} />
                <div>
                  <h1 className="tituloSecundario my-[30px] text-center md:text-start">
                    Quién lidera Pide y Pasa
                  </h1>
                  <p className="textoGeneral text-justify">
                    En Pide y Pasa, hemos desarrollado una cultura centrada en
                    la integridad, tanto para nuestros usuarios, socios de
                    plataforma como para nuestros empleados. Nuestro equipo de
                    trabajo se dedica incansablemente a impulsar el crecimiento
                    de negocio del sector retail gastronómico, ofreciendo
                    soluciones integrales y esenciales en todo momento.
                  </p>
                </div>
              </div>
              <div className="flex flex-col  my-[30px]">
                <img src={personTwo} />
                <div>
                  <h1 className="tituloSecundario my-[30px] text-center md:text-start">
                    Actuar con honestidad
                  </h1>
                  <p className="textoGeneral text-justify">
                    Nuestros valores corporativos se fundamentan en la
                    integridad y la honestidad, siendo estos pilares básicos de
                    nuestra empresa. La ética es de vital importancia en todos
                    los niveles de conocimiento para llevar a cabo nuestras
                    labores de manera transparente. Logramos esta ética al ser
                    empáticos con los demás y mantener nuestros valores
                    presentes en todo momento.
                  </p>
                </div>
              </div>
            </div>

            <div className=" rounded-md">
              <div
                className="h-[20rem] md:h-[35rem] w-full"
                style={{
                  backgroundImage: `url(${fakeImage})`,
                  //height: "40rem",
                  backgroundSize: 'cover'
                }}
              />
            </div>

            <div className="text-center  lg:w-[100%] md:text-start md:mt-[100px] md:mb-[100px] mb-10">
              <h1 className="  mt-[30px] mb-[30px] tituloSecundario">
                Trabajo en equipo
              </h1>
              <p className="text-base md:text-lg text-justify  mb-[50px] textoGeneral">
                Nuestro objetivo es crear un ambiente laboral que refleje
                nuestra cultura organizacional en cada uno de los lugares donde
                operamos. Buscamos fomentar un lugar donde todos los miembros
                puedan contribuir con sus ideas de manera genuina. Al generar un
                entorno en el que las personas de diversas procedencias puedan
                prosperar, celebramos la autenticidad como una fortaleza.
                Creamos equipos holocráticos que contribuyan a que Pide y Pasa
                sea siempre un espacio en el que nuestros empleados y clientes
                se sientan plenamente identificados.
              </p>
              <Link
                to="/trabaja-con-nosotros"
                className="font-bold text-xl underline"
                type="button"
              >
                Trabaja con nosotros
              </Link>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  )
}

export default AboutUs
